import { ResourceType } from '../../../../../../backend';
import { ResourceFieldsLineBoardingGateProperties } from './UnsharedProperties/ResourceFieldsLineBoardingGateProperties';
import { ResourceFieldsLineCheckInProperties } from './UnsharedProperties/ResourceFieldsLineCheckInProperties';
import { ResourceFieldsLineHallProperties } from './UnsharedProperties/ResourceFieldsLineHallProperties';
import { ResourceFieldsLineParkingProperties } from './UnsharedProperties/ResourceFieldsLineParkingProperties';
import { ResourceFieldsLineTerminalProperties } from './UnsharedProperties/ResourceFieldsLineTerminalProperties';

export const ComponentByType: Record<
    ResourceType,
    React.FC<{
        index: number;
        arrayReplace: (index: number, value: any) => void;
    }>
> = {
    [ResourceType.PARKING]: ResourceFieldsLineParkingProperties,
    [ResourceType.TERMINAL]: ResourceFieldsLineTerminalProperties,
    [ResourceType.ARR_HALL]: ResourceFieldsLineHallProperties,
    [ResourceType.DEP_HALL]: ResourceFieldsLineHallProperties,
    [ResourceType.CHECK_IN]: ResourceFieldsLineCheckInProperties,
    [ResourceType.BOARDING_GATE]: ResourceFieldsLineBoardingGateProperties,
};
